import "./styles.scss";

import React, { useState } from "react";
import { Link } from "gatsby";
import Lightbox from "react-image-lightbox";
import clsx from "clsx";

import { useMainGlobal } from "context/main-global";

import Heading from "components/Heading";

import { getColorVariant } from "utils";

const Gallery = () => {
  const { galleryData } = useMainGlobal();

  const [imageIndex, setImageIndex] = useState(null);

  const data =
    galleryData?.length > 0
      ? galleryData.map((item) => item?.sourceUrl).filter((item) => item)
      : undefined;
  const redirectUrl = "/galeria/";

  const gatsbyData =
    galleryData?.length > 0
      ? galleryData.map((item) => item?.sourceUrl).filter((item) => item)
      : undefined;

  return (
    data && (
      <section className="main-gallery">
        <div className="container">
          <Heading title="Galeria" url={redirectUrl} />
          <div className="row d-none d-md-flex">
            <div className="col-8 col-md-9">
              <div
                className="main-gallery__image main-gallery__image--featured"
                style={{ backgroundImage: `url(${gatsbyData[0]})` }}
              >
                <img src={gatsbyData[0]} alt="" />
                <button type="button" onClick={() => setImageIndex(0)}>
                  Powiększ
                </button>
              </div>
            </div>
            <div className="col-4 col-md-3">
              <div className="main-gallery__wrapper">
                {gatsbyData.slice(1).map((item, index) => (
                  <div key={index} className={getColorVariant(index + 1)}>
                    <div className="main-gallery__image">
                      <img src={item} alt="" />
                      <button
                        type="button"
                        onClick={() => setImageIndex(index + 1)}
                      >
                        Powiększ
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="row d-md-none">
            {gatsbyData.slice(0, 3).map((item, index) => {
              const isFeatured = index === 0;

              return (
                <div key={index} className={`col-${isFeatured ? "12" : "6"}`}>
                  <div
                    className={clsx(
                      "main-gallery__image",
                      isFeatured && "main-gallery__image--featured"
                    )}
                  >
                    <img src={item} alt="" />
                    {isFeatured && (
                      <Link to={redirectUrl}>
                        <img
                          src={
                            require("assets/icons/arrow-right--new.svg").default
                          }
                          alt=""
                        />
                      </Link>
                    )}
                    <button type="button" onClick={() => setImageIndex(index)}>
                      Powiększ
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {imageIndex !== null && (
          <Lightbox
            mainSrc={data[imageIndex]}
            nextSrc={data[(imageIndex + 1) % data.length]}
            prevSrc={data[(imageIndex + data.length - 1) % data.length]}
            onCloseRequest={() => setImageIndex(null)}
            onMovePrevRequest={() =>
              setImageIndex((imageIndex + data.length - 1) % data.length)
            }
            onMoveNextRequest={() =>
              setImageIndex((imageIndex + 1) % data.length)
            }
          />
        )}
      </section>
    )
  );
};

export default Gallery;
